import React from 'react'
import { Box, makeStyles, createStyles, Typography } from '@material-ui/core'

const ErrorPage  = () => {
  const classes = useStyles()
  return(
    <Box style={{height:'100vh', width:'100vw', textAlign:'center'}}>
      <Typography color="error" variant='h2'>
        Error
      </Typography>
      <Typography>
        The policy you're trying to see is not available.
      </Typography>
    </Box>
  )
}

const useStyles = makeStyles(theme =>
  createStyles({

  })
)

export default ErrorPage